<div>
    <div class="row">
        <div class="col-md-12" data-html2canvas-ignore>
            <button class="btn btn-primary btn-sm" style="margin-left: 10px; margin-top: 10px"
                (click)="printPackingSlipClick()">
                Print
            </button>
            <button type="button" class="btn-close float-end" data-bs-dismiss="modal" aria-label="Close"
                style="margin-right: 10px; margin-top: 10px" (click)="closeModalClick()"></button>
        </div>
        <div class="card-print" id="shipping_slip" #shipping_slip>
            <div class="card-header">
                <div class="row">
                    <h4 style="text-align: center; font-weight: bold;">Packing Slip</h4>
                </div>
                <div class="row">
                    <div class="col-6">
                        <p style="line-height: 1.25">
                            <span style="font-weight: bold">Sender:</span><br />
                            <span>{{sharedService?.company_info?.company_name}}</span><br />
                            @if (company_street_address && !company_street_address.includes('null')) {
                            <span>{{ company_street_address }}</span>
                            }<br />
                            @if (company_city_state_zip && !company_city_state_zip.includes('null')) {
                            <span>{{ company_city_state_zip }}</span>
                            }<br />
                            @if (sharedService.company_info?.phone_number &&
                            !sharedService.company_info.phone_number.includes('null')) {
                            <span>
                                {{sharedService.company_info.phone_number}}
                            </span>
                            }<br />
                            @if (sharedService.company_info?.customer_facing_email &&
                            !sharedService.company_info.customer_facing_email.includes('null')) {
                            <span>
                                {{sharedService.company_info.customer_facing_email}}
                            </span>
                            }<br />
                            @if (sharedService.company_info?.website &&
                            !sharedService.company_info.website.includes('null')) {
                            <span>{{
                                sharedService.company_info.website
                                }}</span>
                            }<br />
                        </p>
                    </div>
                    <div class="col-6">
                        <p style="line-height: 1.25; margin-left:200px">
                            <span style="font-weight: bold">Ship To: </span>
                            <span>{{ customer_info?.contact?.display_name | capitalizeFirst }}</span><br />
                            @if (disposition_items[0]?.d_ffl) {
                                 <span style="font-weight: bold">FFL: </span>
                            <span> {{ disposition_items[0]?.d_ffl.toUpperCase() }}</span><br />
                            }<br />
                            @if (customer_street_address && !customer_street_address.includes('null')) {
                            <span>{{ customer_street_address }}</span>
                            }<br />
                            @if (customer_city_state_zip && !customer_city_state_zip.includes('null')) {
                            <span>{{ customer_city_state_zip }}</span>
                            }<br />
                        </p>
                    </div>
                </div>
            </div>
            <hr />
            <div class="card-body">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Manufacture</th>
                            <th>Firearm Type</th>
                            <th>Model</th>
                            <th>Caliber / Gauge</th>
                            <th>Serial Number</th>
                            <th>Serial Number</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (item of disposition_items; track item) {
                        <tr>
                            <td>{{ item.a_manufacture.toUpperCase() }}</td>
                            <td>{{ item.a_firearm_type.toUpperCase() }}</td>
                            <td>{{ item.a_model.toUpperCase() }}</td>
                            <td>{{ item.a_caliber_gauge.toUpperCase() }}</td>
                            <td>{{ item.a_serial_number.toUpperCase() }}</td>
                            <td class="barcode">{{ '*' + item.a_serial_number.toUpperCase() + '*' }}</td>
                        </tr>
                        }
                    </tbody>
                </table>
                <hr />
                <div class="row">
                    <div class="col-6">
                        <div class="form-controls-row" data-html2canvas-ignore>
                            <div class="form-control-group">
                                <ng-select [items]="accountingService.customers" bindLabel="contact.display_name"
                                    [(ngModel)]="selected_customer" [multiple]="false" [closeOnSelect]="true"
                                    appendTo="body" class="form-control text-uppercase input" id="customer"
                                    [placeholder]="customer_placeholder"
                                    (change)="getCustomerInfo(); customerDynamicPlaceholder()"
                                    (clear)="clearCustomerFields()">
                                    <ng-template ng-option-tmp let-item="item">
                                        <div [title]="item.contact.display_name">
                                            {{ item.contact.display_name }}
                                          
                                            <span style="font-size: smaller; color: gray;">
                                                {{ item.contact.phone_number ?
                                                formatPhoneNumber(item.contact.phone_number) : ''
                                                }}
                                                {{ item.contact.email ? ' | ' + item.contact.email : '' }}
                                            </span>
                                        </div>
                                    </ng-template>
                                </ng-select>
                            </div>
                            <!-- Button Between Selects -->
                            <div class="button-between">
                                @if (!this.selected_customer) {
                                <button type="button" class="btn btn-success btn-sm add-button"
                                    (click)="addNewCustomerClick()" tooltip="Add Customer">
                                    <i class="fa-solid fa-plus"></i>
                                </button>
                                }
                                @if (this.selected_customer) {
                                <button type="button" class="btn btn-warning btn-sm edit-button"
                                    (click)="editCustomerClick()" tooltip="Edit Customer">
                                    <i class="fa-solid fa-pen-to-square"></i>
                                </button>
                                }
                            </div>
                        </div>
                        <div class="row" style="margin-top: 10px;">
                            <div class="col-12">
                                <span style="font-weight: bold">Notes: </span>
                                <textarea [(ngModel)]="notes_value" class="form-control" type="text" id="notes" rows="4"
                                    style="
                                    width: 100%;
                                    height: 50px;
                                    vertical-align: top;
                                    word-wrap: break-word;
                                    text-align: left;
                                    vertical-align: text-top;
                                    resize: none;
                                " placeholder="Enter notes here..." data-html2canvas-ignore></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        @if (selected_customer) {
                        <p style="line-height: 1.25; margin-left: 200px;">
                            <span style="font-weight: bold">Customer: </span>
                            <br />
                            <span>{{ selected_customer?.contact?.display_name | capitalizeFirst }}</span>
                            <br />
                            @if (selected_customer_street_address && !selected_customer_street_address.includes('null'))
                            {
                            <span>{{ selected_customer_street_address?.toUpperCase() }}</span>
                            }
                            <br />
                            @if (selected_customer_city_state_zip && !selected_customer_city_state_zip.includes('null'))
                            {
                            <span>{{ selected_customer_city_state_zip?.toUpperCase() }}</span>
                            }
                            <br />
                            @if (selected_customer?.contact?.phone_number &&
                            !selected_customer?.contact?.phone_number.includes('null'))
                            {
                            <span>{{ formatPhoneNumber(selected_customer?.contact?.phone_number) }}</span>
                            }
                        </p>
                        }
                    </div>
                </div>
                <div class="row" style="margin-top: 5px;">
                    <div class="col-6">
                        @if (getSanitizedFflUrl(); as fflUrl) {
                        <div style="margin-top: 5px; overflow: hidden; height: 315px; border-radius: 4px;"
                            data-html2canvas-ignore>
                            <iframe [src]="fflUrl" width="100%" height="800px"
                                style="border: none; overflow: hidden;" frameborder="0" scrolling="no"></iframe>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>